import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import CardProfileActions from 'actions/CardProfileActions';
import AdminScorecardActions from 'actions/scorecards/AdminScorecardActions';
import EditCardProfileActions from 'actions/EditCardProfileActions';
import CardsProfile from 'records/CardsProfile';
import ToastStore from '@store/toast/ToastStore';
import {browserHistory} from 'react-router';
import {Record} from 'immutable';

@immutableStore
class EditCardProfileStore {
  constructor() {
    this.state = Record({
      initialCardProfile: null,
      cardProfile: null,
      wasErrorFetching: false,
      isLoading: false,
      wasErrorSaving: false,
      isSaving: false,
      showScorecardDialog: false,
      scorecardToAdd: null,
    })();
    this.bindActions(EditCardProfileActions);
    this.bindActions(CardProfileActions);
    this.bindActions(AdminScorecardActions);
  }

  fetch() {
    this.setState({
      initialCardProfile: null,
      cardProfile: null,
      isLoading: true,
      wasErrorFetching: false,
    });
  }

  fetchSuccess(cardProfile) {
    this.setState({
      isLoading: false,
      cardProfile,
      initialCardProfile: cardProfile,
    });
  }

  fetchError() {
    this.setState({isLoading: false, wasErrorFetching: true});
  }

  updateForm(cardProfile) {
    this.setState({cardProfile});
  }

  initializeForm() {
    this.setState({
      initialCardProfile: new CardsProfile(),
      cardProfile: new CardsProfile(),
      wasErrorSaving: false,
      isSaving: false,
    });
  }

  create() {
    this.setState({
      wasErrorSaving: false,
      isSaving: true,
    });
  }

  createSuccess(cardProfile) {
    this.setState({
      initialCardProfile: cardProfile,
      cardProfile,
    });
    browserHistory.goBack();
    ToastStore.addToast({
      type: 'success',
      time: 2000,
      message: 'Scorecard profile saved!',
    });
  }

  createError(error) {
    this.setState({
      wasErrorSaving: true,
      isSaving: false,
    });
    if (error.response.status !== 409) {
      ToastStore.addToast({
        type: 'error',
        message: 'There was a problem saving the scorecard profile.',
      });
    }
  }

  update() {
    this.create();
  }

  updateSuccess(cardProfile) {
    this.createSuccess(cardProfile);
  }

  updateError(error) {
    this.createError(error);
  }

  toggleScorecardDialog() {
    this.setState({
      showScorecardDialog: !this.state.showScorecardDialog,
    });
  }

  createScorecardSuccess(scorecard) {
    const {cardProfile} = this.state;
    this.setState({
      showScorecardDialog: false,
      scorecardToAdd: null,
      cardProfile: cardProfile.set('scorecards', cardProfile.scorecards.push(scorecard)),
    });
  }

  updateScorecardSuccess(scorecard) {
    const {cardProfile} = this.state;
    const index = cardProfile.scorecards.findIndex(
      otherScorecard => otherScorecard.id === scorecard.id
    );
    this.setState({
      showScorecardDialog: false,
      cardProfile: cardProfile.set(
        'scorecards',
        cardProfile.scorecards.remove(index).insert(index, scorecard)
      ),
    });
  }

  selectScorecardToAdd(scorecardToAdd) {
    this.setState({scorecardToAdd});
  }
}

export default alt.createStore(EditCardProfileStore);
